import { render } from "./Fallback.vue?vue&type=template&id=6dd02d60&scoped=true"
import script from "./Fallback.vue?vue&type=script&lang=js"
export * from "./Fallback.vue?vue&type=script&lang=js"

import "./Fallback.vue?vue&type=style&index=0&id=6dd02d60&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd02d60"]])

export default __exports__